import { services } from "../../utils/services-data"
import { Service } from "../cards/Service"
import { Container } from "../shared/Container"
import { Title } from "../shared/Title"

export const Services = () => {
  return (
    <section id="services">
      {" "}
      <Container className="space-y-10 md:space-y-12">
        <div className="mx-auto max-w-3xl space-y-4 text-center">
          <Title>Stop Bouncing between Sites: View Lab Results and Send Email From One Tool</Title>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {services.map((service, key) => (
            <Service key={key} title={service.title} description={service.description} icon={service.icon} />
          ))}
        </div>
      </Container>
    </section>
  )
}
